import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=5cd3af6a&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd3af6a')) {
      api.createRecord('5cd3af6a', component.options)
    } else {
      api.reload('5cd3af6a', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=5cd3af6a&", function () {
      api.rerender('5cd3af6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k3GS74xCZplR/JS/comp/starrating.vue"
export default component.exports